<template>
  <div class="about-page">
    <!-- 页头：按子路由切换标题与导语（原左栏图标导航改为 handoff 内页骨架） -->
    <section class="page-hero">
      <div class="container">
        <h1>{{ current.title }}</h1>
        <p>{{ current.lead }}</p>
      </div>
    </section>

    <section class="band">
      <div class="container">
        <div class="about-grid">
          <!-- 协议 / 介绍页互跳（沿用旧站四个入口，样式改为 handoff 卡片语言） -->
          <aside class="about-nav">
            <router-link
              v-for="item in caselist"
              :key="item.url"
              :to="item.url"
              class="about-nav-item"
            >{{ item.name }}</router-link>
          </aside>

          <div class="about-main">
            <router-view></router-view>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
/* 关于我们 / 用户协议 / 隐私政策 / 认证服务协议 的公共外壳：
   页头 + 左侧文档导航 + 子路由内容；四个子页面的功能与路由保持不变。 */
export default {
  name: 'aboutUs',
  data() {
    return {
      caselist: [
        {
          name: '关于我们',
          url: '/aboutUs/case1',
          title: '关于我们',
          lead: '动态时序科技有限公司成立于 2021 年，是一家专注于商业数据监控及调用服务的大数据技术企业。我们相信，数据的真正价值在于被及时看见和顺畅流动。'
        },
        {
          name: '用户协议',
          url: '/aboutUs/case2',
          title: '用户协议',
          lead: '本协议由您与北京动态时序科技有限公司就动态时序官网提供的产品服务所订立，请在注册使用前仔细阅读。'
        },
        {
          name: '隐私政策',
          url: '/aboutUs/case3',
          title: '隐私政策',
          lead: '本政策说明我们如何收集、使用、存储与保护您的用户信息，以及您对个人信息享有的权利。'
        },
        {
          name: '认证服务协议',
          url: '/aboutUs/case4',
          title: '认证服务协议',
          lead: '使用动态时序官网认证服务前，请阅读并遵守本协议及相关专项规则，特别是免责与责任限制条款。'
        }
      ]
    }
  },
  computed: {
    current() {
      const path = this.$route.path.replace(/\/+$/, '') || '/aboutUs'
      return this.caselist.filter(item => item.url === path)[0] || this.caselist[0]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/aboutUs/index.vue